define("settings/routes/groups/index", ["exports", "@ember/routing/route", "@ember/service", "@ember/template", "@glimmer/tracking"], function (_exports, _route, _service, _template, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _checkOverages;
  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"@ember/service",0,"@ember/template",0,"@glimmer/tracking"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let IndexRoute = _exports.default = (_class = (_checkOverages = /*#__PURE__*/new WeakSet(), class IndexRoute extends _route.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _checkOverages);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "settings", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _defineProperty(this, "groupSorting", ['name']);
      _initializerDefineProperty(this, "groups", _descriptor6, this);
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get isGracePeriod() {
      return Boolean(this.subscriptions.subscription?.isGracePeriod);
    }
    async model() {
      await this.subscriptions.getAllSubscriptionPlans();
      const {
        groups
      } = this.auth;
      if (this.settings.isAccountOwner) {
        return groups;
      }
      return groups.filter(group => {
        const membershipIds = group.memberships.filterBy('isContributor', false).mapBy('user.id');
        return membershipIds.includes(this.auth.currentUserModel.id);
      });
    }
    afterModel(groups) {
      this.groups = groups;
      _classPrivateMethodGet(this, _checkOverages, _checkOverages2).call(this);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "groups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  })), _class);
  function _checkOverages2() {
    const account = this.currentAccount;
    if (account?.shouldWarnOfPlanOverages && !this.isGracePeriod) {
      if (account.hasGroupsOverage) {
        this.alerts.warning(this.intl.t('alerts.account.groups.overages', {
          count: account.groupsOverage
        }), {
          title: this.intl.t('alerts.account.overage')
        });
      }
      if (account.hasSocialProfileOverage) {
        const profileOverages = [account.hasInstagramOverage ? {
          type: 'Instagram',
          count: account.instagramOverage
        } : undefined, account.hasFacebookOverage ? {
          type: 'Facebook',
          count: account.facebookOverage
        } : undefined, account.hasPinterestOverage ? {
          type: 'Pinterest',
          count: account.pinterestOverage
        } : undefined, account.hasTwitterOverage ? {
          type: 'Twitter',
          count: account.twitterOverage
        } : undefined].filter(item => item).map(profile => `<li>${this.intl.t('alerts.account.groups.group.social_profiles.overages.profiles', profile)}</li>`);
        const overageList = `<ul>${profileOverages}</ul>`;
        this.alerts.warning(this.intl.t('alerts.account.groups.group.social_profiles.overages.title', {
          count: account.groupsOverage,
          list: (0, _template.htmlSafe)(overageList)
        }), {
          title: this.intl.t('alerts.account.overage')
        });
      }
    }
  }
});